export * from './lib/vendor-buyer-shared.module';
